const TableBody = ({ columns, data , rowClassName}) => (
  <tbody className="divide-y divide-gray-200">
    {data.map((row, rowIndex) => (
      <tr key={rowIndex} className={rowClassName}>
        {columns.map((col, colIndex) => (
          <td
            key={colIndex}
            className="border border-gray-400 p-2 text-center text-gray-700"
          >
            {col.render
              ? col.render(row[col.accessor], row)
              : row[col.accessor]}
          </td>
        ))}
      </tr>
    ))}
  </tbody>
);

export default TableBody;
